export class Base {
  excluded = false;
}